<template>
  <div class="p-chip p-component customer-routed-chip" role="status">
    <div class="p-chip-text uppercase">{{ text }}</div>
  </div>
</template>

<script lang="ts" setup>
import { toRefs } from 'vue';

import i18n from '@/i18n';

const props = defineProps({
  text: {
    type: String,
    default: () => i18n.global.t('customerRouted.customerRouted'),
  },
});
const { text } = toRefs(props);
</script>

<style>
.customer-routed-chip.p-chip {
  padding: var(--sp-1) var(--sp-2);
  background: var(--unique-light-color);
  color: var(--unique-dark-color);

  .p-chip-text {
    line-height: 1;
    margin-block: 0;
    font-size: 10px;
    font-weight: 700;
  }
}
</style>
